import Echo from 'laravel-echo';
import { PusherPrivateChannel } from 'laravel-echo/dist/channel';
import { JobType, PrintState } from '../../../types/print';
import { View } from '../../../types/types';

window.Pusher = require('pusher-js');

export const executeUsbPrintJob = async (view: View<PrintState>, jobType: JobType): Promise<void> => {
    const { state, update } = view;
    const { lang, documents } = state;

    state.isExecuting = true;
    state.hasFailed = false;
    delete state.result;
    update();

    state.result = {
        type: jobType,
        responseBody: '',
        isSuccess: false,
    };

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: state.socketKey,
        wsHost: state.socketHost,
        wssPort: 443,
        disableStats: true,
        forceTLS: false,
    });

    const privateChannel = window.Echo.private(state.socketChannel) as PusherPrivateChannel;

    privateChannel.subscribed(() => {
        privateChannel.listenForWhisper('print-done', async (resp: Record<string, unknown>) => {
            state.result.responseBody = JSON.stringify(resp);
            state.isExecuting = false;
            state.hasFailed = resp.state === 'error';
            state.result.isSuccess = resp.state === 'success';

            if (state.result.isSuccess && state.returnUrl) {
                if (state.notifySuccessUrl) {
                    $.ajax({
                        type: 'POST',
                        url: state.notifySuccessUrl,
                        async: false,
                    });
                }

                window.location.replace(state.returnUrl);
            }

            if (state.hasFailed) {
                state.result.errorMessage = resp.message as string;
            } else if (!state.result.isSuccess) {
                state.result.errorMessage = lang.errorCode_unexpected;
            }

            if (state.errorReportUrl && state.result.errorMessage) {
                $.ajax({
                    type: 'POST',
                    url: state.errorReportUrl,
                    data: {
                        error: state.result.errorMessage,
                        document: documents[jobType],
                    },
                });
            }

            privateChannel.unsubscribe();

            update();
        });

        privateChannel.whisper('print-job', documents[jobType]);

        const jobTypeV2 = jobType + 'V2' as JobType;
        if (jobTypeV2 in documents) {
            privateChannel.whisper('print-job-v2', documents[jobTypeV2]);
        }
    });
};
